import styled, { css } from 'styled-components';
import { breakpoints } from 'styles/globals';
var sizeMap = {
  '1/2': '50%',
  '1/3': '33.333333%',
  '1/4': '25%',
  '2/3': '66.666666%',
  '3/4': '75%'
};
var gridItemClassName = 'GridItem';
var GridItem = styled.div.attrs({
  className: gridItemClassName
}).withConfig({
  displayName: "GridItem",
  componentId: "sc-1pacsmm-0"
})(["display:inline-block;vertical-align:top;width:", ";", " ", ""], function (p) {
  return p.size ? sizeMap[p.size] : '100%';
}, function (p) {
  return p.mSize && css(["@media (min-width:", "){width:", ";}"], breakpoints.s, sizeMap[p.mSize]);
}, function (p) {
  return p.lSize && css(["@media (min-width:", "){width:", ";}"], breakpoints.m, sizeMap[p.lSize]);
});
export { gridItemClassName };
export default GridItem;